<template>
    <!--

        This component takes some fields and then saves them
        in a datapoint whose route is specified by endpointRoute.
        
        The fields should be listed in an object where
         the keys are the field name and the value the label.
         If the label is null, then the field is hidden. I.e.:
         [
            {
                id: 'field1',
                label: 'label1',
                value: [data goes here]
            },
            {
                id: 'field2',
                label: 'label1',
                value: [data goes here],
                mandatory: true
            },
            {
                id: 'field3',
                label: null, --- this will be hidden 
                value: [data goes here]
            }
            .
            .
            .
         ]
    
    -->
    <div>
        <div class="modal-overlay">
            <div class="modal-content">
                <div class="d-flex flex-row justify-content-between align-items-center mb-3">
                    <slot name="header">

                    </slot>
                    <button type="button" class="close-btn" @click="closeForm"><b-icon icon="x"></b-icon></button>
                </div>
                <div>
                    <div v-for="(field,key) in filteredFields" :key="key"
                        class="form-group">
                        <TextInput
                            v-model="fieldValue[field.id]" 
                            :label="$t(field.label)" 
                            :error="field.mandatory && !fieldValue[field.id]"
                            :placeholder="$t(field.label)" 
                        />
                    </div>
                    <div class="modal-actions">
                        <button type="button" class="btn btn-secondary" @click="closeForm">{{ $t('cancel') }}</button>
                        <button type="button" class="btn btn-primary" @click="saveItem">{{ $t('save') }}</button>
                    </div>
                </div>
                <div>
                    <slot name="footer">
                        
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
  import "@/styles/components/new-item.scss"; 
  
  export default {
    props: {
      endpointRoute: {
        type: String,
        required: true
      },
      fields: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        fieldValue: {}
      };
    },
    methods: {
        saveItem() {
    
            this.$store.commit('showBlockingSpinner');
    
            return this.$cfetch(`${this.$settings.APIBaseURL}/${this.endpointRoute}`, {
                method: 'POST',
                data: this.fieldsToSave
            }).
            then((res) => {
                if(res.status !== 'SUCCESS') {
                    this.$store.commit("openDialog", {
                        title: this.$t("something-went-wrong"),
                        content: this.$t('could-not-save-item'),
                        confirmCallBack: function () {},
                    });
                    throw new Error('Could not save item')
                }
                this.resetForm();
                this.$emit('saved'); 
                this.$emit('close');  
            })
            .catch((err) => this.$log.error.call(this, err))
            .finally(() => this.$store.commit('hideBlockingSpinner'));
      },
      closeForm() {
        this.resetForm();
        this.$emit('close');
      },
      resetForm() {
        this.fieldValue = { };
      },
    },
    computed:{
        filteredFields(){
            return this.fields.filter( x => x.label !== null)
        },
        fieldsToSave(){
            let data = {};

            for(let field of this.fields){
                data[field.id] = this.fieldValue[field.id] ? this.fieldValue[field.id] : field.value
            }

            return data
        }
    }
  };
</script>
  